module["exports"] = [
  "(9##)###-##-##"
];



//////////////////
// WEBPACK FOOTER
// ./~/faker/lib/locales/ru/phone_number/formats.js
// module id = 1319
// module chunks = 0